import PropTypes from 'prop-types'
import React from 'react'
import injectSheet from 'react-jss'
import { withCookies } from 'react-cookie'
import SearchBarMobile from 'src/components/top_bar/SearchBarMobile'
import Producteur from 'src/components/Producteur'
import ButtonLink from 'src/components/button/ButtonLink'
import routes from 'src/routing/routes'
import responsiveComponent from 'src/hoc/responsiveComponent'
import Spinner from '../../../../../../components/Spinner'
import PubContainer from '../../../../../../components/PubContainer'
import { responsiveAd } from '../../../../../../config/dataConf'

const styles = theme => ({
  /// ////// Format Mobile //////////
  hr: {
    borderColor: theme.listeProducteur.hrColor,
    margin: '0px -15px 15px'
  },
  colProd: {
    textAlign: 'center'
  },
  prodContainer: {
    backgroundColor: 'white',
    margin: '-15px',
    padding: '35px 15px 0px'
  },

  /// ////// Format Desktop /////////
  divProd: {
    backgroundColor: 'white',
    margin: '30px 15px 15px 15px'
  },
  colProdAF: {
    marginTop: '50px',
    textAlign: 'center'
  }
})

const onePageListProducers = ({
  classes,
  producers,
  cookies,
  loading,
  isMobile
}) => {
  const token = cookies.get('token')

  return isMobile ? (
    <div className={classes.colProd}>
      <div>
        <SearchBarMobile />
        <hr className={classes.hr} />
      </div>

      <div className={classes.prodContainer}>
        <PubContainer className={classes.pub} scriptPubCore={responsiveAd} />

        {!loading && producers ? (
          producers.map((producteur, i) => (
            <Producteur
              key={i}
              id={producteur.id}
              presentation={producteur.presentation}
              companyName={producteur.companyName.toUpperCase()}
              photoUrlProducer={producteur.photoProducerUrl}
              categories={producteur.categories}
              commune={producteur.addressCity}
              dep={producteur.addressPostalCode.slice(0, 2)}
              distance={producteur.distance}
              isLast={i === producers.length - 1}
            />
          ))
        ) : (
          <Spinner />
        )}
      </div>
    </div>
  ) : (
    <div className={classes.colProdAF}>
      {!token && (
        <ButtonLink
          jaune
          to={routes.inscription}
          className={classes.buttonProducteur}
        >
          Vous êtes producteurs ?
        </ButtonLink>
      )}
      <div className={classes.divProd}>
        <PubContainer className={classes.pub} scriptPubCore={responsiveAd} />

        {!loading && producers ? (
          producers.map((producteur, i) => {
            return (
              <Producteur
                key={i}
                id={producteur.id}
                presentation={producteur.presentation}
                companyName={producteur.companyName.toUpperCase()}
                photoUrlProducer={producteur.photoProducerUrl}
                categories={producteur.categories}
                commune={producteur.addressCity}
                dep={producteur.addressPostalCode.slice(0, 2)}
                distance={producteur.distance}
                isLast={i === producers.length - 1}
              />
            )
          })
        ) : (
          <Spinner />
        )}
      </div>
    </div>
  )
}

onePageListProducers.propTypes = {
  classes: PropTypes.any,
  cookies: PropTypes.any,
  producers: PropTypes.array
}

const withStyles = injectSheet(styles)(onePageListProducers)
export default responsiveComponent(withCookies(withStyles))
